/* global Promise */
const pinPath =
  'M819.1,512.1c0,169.6-137.5,307.2-307.2,307.2S204.7,681.8,204.7,512.1c0-169.7,137.5-307.2,307.2-307.2S819.1,342.5,819.1,512.1z M1023.9,512.1c0,282.3-229.7,512-512,512c-282.3,0-512-229.7-512-512c0-282.3,229.7-512,512-512C794.2,0.1,1023.9,229.8,1023.9,512.1z M947.1,512.1c0-240-195.2-435.2-435.2-435.2S76.7,272.1,76.7,512.1c0,240,195.2,435.2,435.2,435.2S947.1,752.1,947.1,512.1z';

const mapData = {
  type: 'map',
  projection: 'mercator',
  fontFamily: 'Gotham HCo',
  theme: 'light',
  dragMap: false,
  imagesSettings: {
    mouseEnabled: true,
    rollOverColor: '#089282',
    rollOverScale: 3,
    selectedScale: 3,
    selectedColor: '#089282',
    color: '#13564e',
  },

  dataProvider: {
    map: 'worldHigh',
    zoomLevel: 3.0,
    zoomLongitude: 60,
    zoomLatitude: 32,
  },

  areasSettings: {
    balloonText: '',
    autoZoom: false,
    selectable: true,
    color: '#ececec',
    rollOverColor: '#999999',
    unlistedAreasColor: '#ececec',
    selectedColor: '#3aec9c',
    alpha: 1,
    unlistedAreasAlpha: 1,
    outlineThickness: 0.3,
  },

  export: {
    enabled: true,
  },
  panEventsEnabled: false,
  zoomDuration: 0.5,
  zoomOnDoubleClick: false,
  zoomControl: {
    zoomControlEnabled: false,
    homeButtonEnabled: false,
  },
};

class ConfigGenerator {
  constructor(options) {
    this.endpoint = options.endpoint;
  }

  getAreaData(entry) {
    return {
      id: entry.country_code,
      images: [],
      customData: {
        zoomLevel: entry.country_zoom_level,
        zoomLatitude: entry.country_zoom_latitude,
        zoomLongitude: entry.country_zoom_longitude,
      },
    };
  }

  getImageData(entry) {
    const hasMarkerProperty = entry.show_country_marker;
    let groupId = '';

    if (hasMarkerProperty) {
      groupId = entry.show_country_marker ? 'country' : `factory-${entry.factory_id}`;
    } else {
      groupId = 'global';
    }

    const customDataId = hasMarkerProperty ? entry.address.country.isocode : entry.country_code;
    const customDataLabel = hasMarkerProperty ? entry.address.country.name : entry.country_name;
    const latitude = hasMarkerProperty ? entry.address.latitude : entry.country_latitude;
    const longitude = hasMarkerProperty ? entry.address.longitude : entry.country_longitude;

    return {
      groupId,
      customData: {
        id: customDataId,
        label: customDataLabel,
        scale: {
          mobile: 0.02,
          desktop: 0.02,
        },
      },
      label: '',
      labelColor: '#000000',
      labelRollOverColor: '#000000',
      labelFontSize: 18,
      svgPath: pinPath,
      scale: 0.024,
      rollOverScale: 1,
      color: '#000000',
      rollOverColor: '#000000',
      latitude,
      longitude,
      selectable: true,
      selectedColor: '#000000',
      selectedScale: 1,
      linkToObject: customDataId,
    };
  }

  getMapData() {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', this.endpoint);
      xhr.onload = () => {
        if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);
          const areasArray = [];
          const imagesArray = [];

          const countries = response.worldwide_countries;
          for (let i = 0, { length } = countries; i < length; i++) {
            areasArray.push(this.getAreaData(countries[i]));
            imagesArray.push(this.getImageData(countries[i]));

            const factories = countries[i].country_factories;
            for (let i = 0, { length } = factories; i < length; i++) {
              imagesArray.push(this.getImageData(factories[i]));
            }
          }

          mapData.dataProvider.areas = areasArray;
          mapData.dataProvider.images = imagesArray;

          resolve(mapData);
        } else {
          resolve(mapData);
        }
      };
      xhr.onerror = () => reject(xhr.statusText);
      xhr.send();
    });
  }
}

export default ConfigGenerator;
